<div class="row mt-2 no-gutters">
  <div class="col">
    <small *ngIf="account.category== 'RENTAL_FLEET'"><a [routerLink]="['/rental-fleet']" class="text-secondary">Admin
        Console</a>
      /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
      /<a (click)="closeVehicleDetailClicked(null);showSearchResult = false;" class="text-secondary pointer">
        Vehicles</a></small>
    <small *ngIf="account.category== 'FLEET_MANAGEMENT_COMPANY' || account.category == 'MOBILITY_COMPANY' || account.category == 'FIELD_SERVICE_COMPANY'"><a [routerLink]="['/commercial-fleet']"
        class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
      /<a (click)="closeVehicleDetailClicked(null);showSearchResult = false;" class="text-secondary"> Vehicles</a>
    </small>

    <small *ngIf="account.type == 'VEHICLE_SERVICE_PROVIDER' && account.category== 'MOBILITY_SERVICE'"><a
        [routerLink]="['/service-provider/dashboard']" class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/service-provider/account-management']" class="text-secondary"> Account Management</a>
      /<a (click)="closeVehicleDetailClicked(null);showSearchResult = false;" class="text-secondary"> Vehicles</a>
    </small>
    <small *ngIf="account.category== 'DEALER'"><a [routerLink]="['/dealer']" class="text-secondary">Admin
        Console</a>
      /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
      /<a (click)="closeVehicleDetailClicked(null);showSearchResult = false;" class="text-secondary pointer">
        Vehicles</a></small>
    
      <small *ngIf="account.category== 'CORPORATE' || account.category == 'FINANCING_GROUP'"><a [routerLink]="['/corporate']" class="text-secondary">Admin
          Console</a>
        /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
        /<a (click)="closeVehicleDetailClicked(null);showSearchResult = false;" class="text-secondary pointer">
          Vehicles</a></small>
          <small>
      <ng-container *ngIf="isViewVehicleDetail">
        /<a class="text-secondary"> {{selectedVehicle.vin}}</a>
      </ng-container>
    </small>
    <small *ngIf="showSearchResult">
      <a class="text-secondary pointer" (click)="searchResult.onNavSearchClick()">/ Search</a>
      <a *ngIf="selectedSearchItemForView" class="text-secondary"> / {{selectedSearchItemForView}}</a>
    </small>
  </div>
</div>

<div *ngIf="showSearchResult" class="row mt-2 no-gutters">
  <div class="col-12">
    <app-search-results [vehicleList]="searchedVehicleList" (selectedItemEmitter)="onSearchItemDetail($event);"
      (selectedItemCloseEmitter)="selectedSearchItemForView=null;" #searchResult></app-search-results>
  </div>
</div>

<div *ngIf="!showSearchResult">
  <div *ngIf="!isViewVehicleDetail else vehicleDetail">
    <div *ngIf="account && account.type != vehicleServiceProviderType" class="row pt-2 pb-1 no-gutters">
      <div class="col-12 text-right">
        <!-- <button type="button" class="btn btn-primary border mr-md-1 d-sm-inline-block btn-165" data-toggle="modal"
          data-target="#enrollVehicles" data-backdrop="static" data-keyboard="false"
          (click)="enrollVehiclesModal.initModalParameters(enrollVehicles)">Enroll Vehicles</button> -->
          
          <!-- <button class="btn btn-primary border mr-md-1 d-none d-sm-inline-block btn-100" data-toggle="modal"
            data-target="#addVehicle" data-backdrop="static" data-keyboard="false">Add</button> -->
          <!-- <button class="btn btn-primary border mr-md-1 d-none d-sm-inline-block btn-100" data-toggle="modal"
            data-target="#importVehicles" data-backdrop="static"
            data-keyboard="false">Import</button> -->
            <!-- &nbsp; <span><i class="fas fa-chevron-right"></i></span> -->
          <button type="button" class="btn btn-primary border mr-md-1 d-sm-inline-block btn-100" data-toggle="modal"
            data-target="#enrollVehicles" data-backdrop="static" data-keyboard="false"
            (click)="enrollVehiclesModal.initModalParameters(enrollVehicles)">Enroll</button>
          <button type="button" class="btn btn-primary border mr-md-1 d-sm-inline-block btn-100" data-toggle="modal"
            data-target="#enrollVehicles" data-backdrop="static" data-keyboard="false"
            (click)="enrollVehiclesModal.initModalParameters(unenrollVehicles)">Unenroll</button>

        <!-- <button class="btn btn-primary border mr-3 d-none d-sm-inline-block" data-toggle="modal"
      data-target="#importVehicles" data-backdrop="static" data-keyboard="false">Import Vehicles
      &nbsp;<span><i class="fas fa-chevron-right"></i></span></button>
    <button class="btn btn-primary border" data-toggle="modal" data-target="#addVehicle" data-backdrop="static"
      data-keyboard="false">Add A Vehicle
      &nbsp;<span><i class="fas fa-chevron-right"></i></span></button> -->
        <!-- <div class="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6" style="padding-left:3px; padding-right: 3px"> -->
        <!-- <button class="btn btn-primary border mr-3 d-none d-sm-inline-block" data-toggle="modal" data-target="#addVehicle"
        data-backdrop="static" data-keyboard="false">Add A Vehicle
        &nbsp;<span><i class="fas fa-chevron-right"></i></span></button> -->
        <!-- </div> -->
        <!-- <div class="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-2 d-none d-sm-inline-block" -->
        <!-- style="padding-left:3px; padding-right: 3px"> -->
        <!-- <button class="btn btn-primary border mr-3 d-none d-sm-inline-block" data-toggle="modal"
        data-target="#importVehicles" data-backdrop="static" data-keyboard="false">Import Vehicles
        &nbsp;<span><i class="fas fa-chevron-right"></i></span></button> -->
        <!-- </div> -->
        <!-- <div class="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-2 d-none d-sm-inline-block"
        style="padding-left:3px; padding-right: 3px"> -->
        <!-- <button class="btn btn-primary border d-none d-sm-inline-block" (click)="importFile = null"
        data-toggle="modal" data-target="#importremoveVehicle" data-backdrop="static" data-keyboard="false">DEFLEET VEHICLES</button> -->
        <!-- </div> -->
      </div>
    </div>



    <!-- <div class="row mt-3 bg-light pb-1">
  <div class="col-lg-3 col-md-3 col-sm-3 col-3 text-center pr-0 pl-0">
    <h5 class="mb-0">4</h5>
    <div>Connected Electric Vehicles</div>
  </div>
  <div class="col-lg-3 col-md-3 col-sm-3 col-3 text-center pr-0 padl-5">
    <h5 class="mb-0">16</h5>
    <div>Connected ICE Vehicles</div>
  </div>
  <div class="col-lg-3 col-md-3 col-sm-3 col-3 text-center pr-0 padl-5">
    <h5 class="mb-0">7</h5>
    <div>Active B2B Subscriptions</div>
  </div>
  <div class="col-lg-3 col-md-3 col-sm-3 col-3 text-center pr-0 padl-5">
    <h5 class="mb-0">13</h5>
    <div>Active Consumer Subscriptions</div>
  </div>
</div> -->

    <div class="row py-3 no-gutters">
      <!-- <div class="col-sm-2 align-center mt-2 d-none d-sm-block">
    <span>Connected Vehicles</span><br>
    <h3>{{vehicleList.length}}</h3>
  </div>
  <div class="col-sm-2 align-center mt-2 d-block d-sm-none">
    <h6>Connected Vehicles : {{vehicleList.length}}</h6>
  </div> -->
      <div class="col-12 table-responsive no-gutters">
        <table class="table table-striped tbl-scrollable">
          <thead class="thead-light">
            <tr>
              <th scope="col" width="7%" class="text-center">
                <button class="btn btn-outline-danger py-0 delete-button" [disabled]="selectedVehicles.length < 1"
                  (click)="onDeleteVehicles()"><i class="fa fa-trash"></i></button>
              </th>
              <th scope="col" width="7%" class="text-center">
                <button class="btn btn-outline-danger py-0 delete-button" (click)="refreshVehicleList()"><i
                    class="fa fa-refresh"></i></button>
              </th>
              <th scope="col" width="15%">VIN</th>
              <th scope="col" width="8%">Make</th>
              <th scope="col" width="10%">Model</th>
              <th scope="col" width="7%">Year</th>
              <!-- <th *ngIf="!['DEALER', 'CORPORATE'].includes(account.category)" scope="col" width="12%" class="px-0"> -->
              <th *ngIf="!isDongleDeviceSupported()" scope="col" width="12%" class="px-0">
                <select (change)="onCertificateChange()" [(ngModel)]="selectedCertificateFilterOption">
                  <option [ngValue]="null">Certificate Id</option>
                  <option [ngValue]="item" *ngFor="let item of certificatesFilterOptions;">{{item}}</option>
                </select>
              </th>
              <th scope="col" width="10%" class="px-0">
                <select (change)="getPaginatedAccountVehicles(0)" [(ngModel)]="vehicleFilters.status">
                  <option [ngValue]="null">Status</option>
                  <option [ngValue]="item" *ngFor="let item of vehicleStatusFilterOptions;">{{item | customText}}
                  </option>
                </select>
              </th>
              <th scope="col" width="14%" class="px-0">
                <select (change)="getPaginatedAccountVehicles(0)" [(ngModel)]="vehicleFilters.enrollmentStatus">
                  <option [ngValue]="null">Enrollment Status</option>
                  <option [ngValue]="item" *ngFor="let item of enrollmentStatusFilterOptions;">
                    <!-- <span *ngIf="item == 'ENROLLMENT_IN_PROGRESS'"> In Progress</span> -->
                    <!-- <span>{{item | customText}}</span> -->
                    <span>{{item.split("|")[0] | customText}}</span>
                  </option>
                </select>
              </th>
              <th scope="col" width="15%" class="px-0">
                <select (change)="getPaginatedAccountVehicles(0)" [(ngModel)]="vehicleFilters.enrollmentEligibility" [disabled]="utilService.isNmacAccount(authService.loggedInUser.accountId)">
                  <option [ngValue]="null">Enrollment Eligible</option>
                  <option [ngValue]="item" *ngFor="let item of enrollmentEligibleFilterOptions;">
                    <span *ngIf="item">Yes</span>
                    <span *ngIf="!item">No</span>
                  </option>
                </select>
              </th>
              <!-- <th *ngIf="['DEALER', 'CORPORATE'].includes(account.category)" scope="col" width="12%" class="px-0"> -->
              <th *ngIf="isDongleDeviceSupported()" scope="col" width="12%" class="px-0">
                <select (change)="getPaginatedAccountVehicles(0)" [(ngModel)]="vehicleFilters.dongleStatus">
                  <option [ngValue]="null">Dongle Status</option>
                  <option [ngValue]="item" *ngFor="let item of dongleStatusFilterOptions;">{{item | customText}}</option>
                </select>
              </th>
            </tr>
          </thead>
          <tbody *ngIf="vehicleList && vehicleList.length>0; else noVehicles" class="max-height-57">
            <!-- <tr> -->
            <tr *ngFor="let vehicle of vehicleList; let i = index" class="pointer">
              <th scope="row" width="7%" class="text-center pr-0">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" name="checkbox" class="custom-control-input"
                    [checked]="isVehicleSelected(vehicle.vin)"
                    (change)="onVehicleSelectionChange($event.target.checked, vehicle)" id="vehicle_{{i}}">
                  <label class="custom-control-label" for="vehicle_{{i}}"></label>
                </div>
              </th>
              <td width="7%" class="px-0 text-center" (click)="vehicleSelected(vehicle)">
                <img class="vehicle-image-sm" src="{{getVehicleLogo(vehicle)}}" alt="{{vehicle.model}}" />
              </td>
              <td scope="row" width="15%" (click)="vehicleSelected(vehicle)">{{vehicle.vin}}</td>
              <td scope="row" width="8%" (click)="vehicleSelected(vehicle)">{{vehicle.make | uppercase}}</td>
              <td width="10%" (click)="vehicleSelected(vehicle)"> {{vehicle.model | uppercase}}</td>
              <td width="7%" [ngClass]="vehicle.year ? '': 'text-center'" (click)="vehicleSelected(vehicle)"><span
                  *ngIf="vehicle.year; else valueNotAvailable">{{vehicle.year}}</span></td>
              <!-- <td *ngIf="!['DEALER', 'CORPORATE'].includes(account.category)" width="12%" (click)="vehicleSelected(vehicle)"> -->
              <td *ngIf="!isDongleDeviceSupported()" width="12%" (click)="vehicleSelected(vehicle)">
                <span *ngIf="account.oemCustomerId != vehicle.oemCustomerId">{{vehicle.oemCustomerId}}</span>
              </td>
              <td width="10%" (click)="vehicleSelected(vehicle)">
                <i
                  [ngClass]="{'ACTIVE':'fa fa-check-circle text-success', 'ENROLLED':'fa fa-check-circle text-success', 'INACTIVE':'fa fa-exclamation-circle text-danger', 'PROVISIONED':'fa fa-minus-circle text-warning',
              'PENDING':'fa fa-minus-circle text-warning', 'ASSIGNED':'fa fa-minus-circle text-warning', 'ORDERED':'fa fa-exclamation-circle text-danger', 'DELIVERED':'fa fa-exclamation-circle text-danger', 'DELETED':'fa fa-exclamation-circle text-danger'}[vehicle.status]"></i>
                {{vehicle.status | customText}}
              </td>
              <td width="14%" [ngClass]="vehicle.enrollmentStatus ? '': 'text-center'"
                (click)="vehicleSelected(vehicle)">
                <span *ngIf="vehicle.enrollmentStatus; else valueNotAvailable">
                  {{getVehicleEnrollmentStatus(vehicle) | customText}}
                </span>
              </td>
              <!-- <td width="10%" [ngClass]="vehicle.enrollmentStatus == 'NOT_ENROLLED' ? '': 'text-center'" (click)="vehicleSelected(vehicle)"> -->
              <td width="15%" class="text-center" (click)="vehicleSelected(vehicle)">
                <!-- <span *ngIf="vehicle.enrollmentStatus == 'NOT_ENROLLED'; else valueNotAvailable"> -->
                <!-- older enrollment Eligibility criteria
                                <span *ngIf="vehicle.enrollmentEligibility == true">Yes</span>
                                <span *ngIf="vehicle.enrollmentEligibility == false">No</span>
                              -->
                <span *ngIf="utilService.isNmacAccount(authService.loggedInUser.accountId) else noNmac">
                  Yes
                </span>
                <ng-template #noNmac>
                  <span
                    *ngIf="vehicle.enrollmentEligibility == true && vehicle.enrollmentReady == true else enrollmentConditionFalse">Yes</span>
                  <ng-template #enrollmentConditionFalse>
                    No
                  </ng-template>
                </ng-template>
                <!-- </span> -->
              </td>
              <!-- <td *ngIf="['DEALER', 'CORPORATE'].includes(account.category)" width="12%" (click)="vehicleSelected(vehicle)"> -->
              <td *ngIf="isDongleDeviceSupported()" width="12%" (click)="vehicleSelected(vehicle)">
                <span *ngIf="vehicle.deviceStatus && !['NONE','UNLINKED','DELETED'].includes(vehicle.deviceStatus); else valueNotAvailable">
                  <i
                    [ngClass]="{'NONE':'fa fa-exclamation-circle text-danger','ATTACHED':'fa fa-minus-circle text-warning', 'ENABLED':'fa fa-check-circle text-warning', 'LINKED':'fa fa-check-circle text-success', 'UNLINKED':'fa fa-exclamation-circle text-danger', 'DELETED':'fa fa-exclamation-circle text-danger','DISABLED':'fa fa-exclamation-circle text-danger'}[vehicle.deviceStatus]"></i>
                  {{vehicle.deviceStatus | customText}}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <ng-template #valueNotAvailable>
          <span>-</span>
        </ng-template>
      </div>
      <div class="col-12 text-right">
        <span *ngIf="previousPage != null" class="pointer" (click)="getPreviousPage()">
          << Previous</span>
            <span *ngIf="nextPage != null" class="pointer" (click)="getNextPage()">&nbsp;&nbsp;&nbsp;&nbsp;Next >>
            </span>
      </div>
    </div>
    <ng-template #noVehicles>
      <div class="col-12 text-center mt-5 mb-5 text-muted">
        <h3>No vehicle available</h3>
      </div>
    </ng-template>
  </div>
  <ng-template #vehicleDetail>
    <app-view-vehicle-detail [vehicleData]="selectedVehicle" (closeEmitter)="closeVehicleDetailClicked($event)">
    </app-view-vehicle-detail>
  </ng-template>
</div>

<!-- Add vehicle modal -->
<div class="modal fade" id="addVehicle" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="addVehicleTitle">Add Vehicle</h5>
        <button id="closeAddVehicle" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" (click)="resetAddVehicleForm()">&times;</span>
        </button>
      </div>
      <form name="addVehicle" #addVehicleForm="ngForm" novalidate (ngSubmit)="onCreateVehicle(addVehicleForm)">
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-3 col-3 pr-0 text-center">
              <div *ngIf="!vehicle.logo">
                <img src="assets/images/placeholder.png" class="img-thumbnail full-img">
              </div>
              <div *ngIf="vehicle.logo">
                <img [src]="vehicle.logo" class="img-thumbnail full-img">
              </div>
              <div style="height:0px;overflow:hidden">
                <input #uploadvehicleLogo (click)="uploadvehicleLogo.value=null" id="uploadLogoInput"
                  name="uploadLogoInput" type="file" (change)="uploadVehicleLogo($event)" accept=".jpg,.png">
              </div>
              <small><a style="cursor:pointer" (click)="uploadVehicleLogoClicked()"><u>Upload Logo</u></a></small>
            </div>
            <div class="col-lg-10 col-md-10 col-sm-9 col-9">
              <div class="form-group">
                <label for="vin"><span class="maroon astrisk">&#10033;&nbsp;</span>VIN</label>
                <input type="text" class="form-control" id="vin" name="vin" placeholder="vin" required
                  [(ngModel)]="vehicle.vin" #vin="ngModel" pattern="[A-Z0-9]{17}" minlength="17">
                <small class="text-danger text-center" *ngIf="vin.errors && addVehicleForm.submitted">
                  <p class="mb-0" *ngIf="vin.errors.required">*Required</p>
                  <p class="mb-0" *ngIf="!vin.errors.required">Invalid vin</p>
                </small>
              </div>
              <div class="form-group">
                <label for="make"><span class="maroon astrisk">&#10033;&nbsp;</span>Make</label>
                <input type="text" class="form-control" id="make" name="make" placeholder="Make" required
                  [(ngModel)]="vehicle.make" #make="ngModel" (blur)="invalidMake=false">
                <small class="text-danger text-center" *ngIf="make.errors && addVehicleForm.submitted">
                  <p class="mb-0" *ngIf="make.errors.required">*Required</p>
                </small>
                <small class="text-danger text-center" *ngIf="!make.errors && addVehicleForm.submitted && invalidMake">
                  <p class="mb-0">Make can only be Nissan or Infiniti</p>
                </small>
              </div>
              <div class="form-group">
                <label for="model"><span class="maroon astrisk">&#10033;&nbsp;</span>Model</label>
                <input type="text" class="form-control" id="model" name="model" placeholder="Model" required
                  [(ngModel)]="vehicle.model" #model="ngModel">
                <small class="text-danger text-center" *ngIf="model.errors && addVehicleForm.submitted">
                  <p class="mb-0" *ngIf="model.errors.required">*Required</p>
                </small>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="year"><span class="maroon astrisk">&#10033;&nbsp;</span>Year</label>
                    <input type="number" class="form-control" id="year" name="year" placeholder="Year" required
                      [(ngModel)]="vehicle.year" #year="ngModel" [customMin]="minYear" [customMax]="maxYear">
                    <small class="text-danger text-center" *ngIf="year.errors && addVehicleForm.submitted">
                      <p class="mb-0" *ngIf="year.errors.required">*Required</p>
                      <p class="mb-0"
                        *ngIf="!year.errors.required && (year.errors?.customMin || year.errors?.customMax)">Year can be
                        between {{minYear}} - {{maxYear}}</p>
                    </small>
                  </div>

                </div>
                <div class="col pl-0">
                  <div class="form-group">
                    <label for="color"> Color</label>
                    <input type="text" class="form-control" id="color" name="color" placeholder="Color"
                      [(ngModel)]="vehicle.color" #color="ngModel">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light btn-80" data-dismiss="modal"
            (click)="resetAddVehicleForm()">CANCEL</button>
          <button type="submit" class="btn btn-primary btn-80">SAVE</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Import removeVehicle modal -->
<div class="modal fade" id="importremoveVehicle" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="importremoveVehicleTitle">Remove Vehicles from {{account.name}}</h5>
        <button id="closeRemoveVehicle" type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="resetRemoveVehicleImport()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-2 pb-2 hide-x-scroll">
        <div class="form-group mb-0">
          <label class="heading">Upload UTF-8 Encoded CSV File</label><br>
          <label class="mt-2"><span class="text-muted font13-400">AccountId for {{account.name}}
              :</span><br>{{account.id}}</label>
          <div class="row mt-2 mb-3">
            <div class="col-12">
              <div class="custom-file">
                <input #vehiclesCompRemoveVehiclesFromAccountInput type="file" accept=".csv" class="custom-file-input"
                  id="removeVehicleImport" (change)="onFileSelected($event.target.files, 'RemoveVehicle')">
                <label class="custom-file-label" for="removeVehicleImport">{{importFileName.substring(0,40)}} <span
                    *ngIf="importFileName != CHOOSE_FILE">...</span></label>
              </div>
            </div>
            <div class="col-12" *ngIf="importFileName != CHOOSE_FILE"><span class="font11-400">{{importFileName}}</span>
            </div>
          </div>

          <label>
            <span class="text-muted font13-400">Format for Remove Vehicle
              filename:</span><br>
            NCC_RemoveVehicle_&lt;accountId&gt;_&lt;timestamp&gt;.csv</label><br>

          <label class="mt-1">
            <span class="text-muted font13-400">For example :</span><br>
            NCC_RemoveVehicle_{{account.id}}_05132019101630.csv</label><br>

          <label class="mt-2">
            <span class="text-muted font13-400">CSV file data format :</span><br>
            VIN, reasonCode</label><br>
          <ul>
            <li class="text-muted txt-small">Both the fields are mandatory.</li>
            <li class="text-muted txt-small">ReasonCode could have value : SOLD.
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" data-dismiss="modal"
          (click)="resetRemoveVehicleImport()">CANCEL</button>
        <button type="button" class="btn btn-primary btn-80" [disabled]="importFile == null"
          (click)="uploadFile()">UPLOAD</button>
      </div>
    </div>
  </div>
</div>

<app-review-vehicles [vehicles]="selectedVehicles" [reviewVehiclesHeader]="reviewVehicleModalMessages.header"
  [reviewVehiclesMessage]="reviewVehicleModalMessages.message" [reviewVehiclesNote]="reviewVehicleModalMessages.note"
  (closeEmitter)="resetSelectedVehicles()" (saveEmitter)="reviewVehiclesSubmit($event)"></app-review-vehicles>


  <div class="modal fade" id="importVehicles" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header popup-header">
          <h5 class="modal-title" id="importVehiclesTitle">Import Vehicles</h5>
          <button id="closeImportVehicle" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body pt-2 pb-2 hide-x-scroll">
          <div class="form-group mb-0">
            <label class="heading">Upload UTF-8 Encoded CSV File</label>
  
            <div class="row mt-2 mb-3">
              <div class="col-12">
                <div class="custom-file">
                  <input type="file" accept=".csv" class="custom-file-input" id="vehicleImport"
                    (change)="onVehicleFileSelected($event.target.files)">
                  <label class="custom-file-label" for="vehicleImport">{{importFileName.substring(0,40)}} <span
                      *ngIf="importFileName != CHOOSE_FILE">...</span></label>
                </div>
              </div>
              <div class="col-12" *ngIf="importFileName != CHOOSE_FILE"><span class="font11-400">{{importFileName}}</span>
              </div>
            </div>
  
            <label class="text-muted txt-small">
              <span>Download the <a class="a_format" (click)="downloadSampleCsv()">sample CSV file</a> for a vehicles list
                template.&nbsp;</span>
              <span>Ensure to remove the example vehicle record before adding your own list and update the date YYYYMMDD
                in filename while saving, for example,&nbsp;</span>
              <br><span class="font12-400">NCC_FleetVehicleEntry_{{yyyymmddDate}}.csv.</span>
            </label>
            <br>
  
            <label class="mt-2">
              <span class="text-muted txt-small">CSV file data format :</span>
              <br>
              <span class="font12-400">
                VIN<sup class="maroon asterisk-8">&#10033;&nbsp;</sup>,
                Make<sup class="maroon asterisk-8">&#10033;&nbsp;</sup>,
                Model<sup class="maroon asterisk-8">&#10033;&nbsp;</sup>,
                ModelYear, ExteriorColor, TCUType,
                IgnitionType<sup class="maroon asterisk-8">&#10033;&nbsp;</sup>,
                LicensePlate, Country<sup class="maroon asterisk-8">&#10033;&nbsp;</sup>, OEMCustomerId, TankSize,
                TransmissionType, Generation
              </span>
            </label>
            <br>
            <ul class="mt-2">
              <li class="text-muted txt-small">Fields marked by <span class="maroon astrisk">&#10033;&nbsp;</span> are
                mandatory</li>
              <li class="text-muted txt-small">The permitted values for the fields :<br>
                <ul>
                  <li class="text-muted txt-small">TCUType : A-IVC</li>
                  <li class="text-muted txt-small">TransmissionType : MANUAL | AUTO</li>
                  <li class="text-muted txt-small">IgnitionType : FUEL | DIESEL | EV</li>
                  <li class="text-muted txt-small">OEMCustomerId : {{utilService.selectedRentalFleetAccount.oemCustomerId}}</li>
                </ul>
              </li>
            </ul>
  
  
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-dismiss="modal">CANCEL</button>
          <button type="button" class="btn btn-primary" (click)="uploadVehicleEntries()">UPLOAD</button>
        </div>
      </div>
    </div>
  </div>

<app-enroll-vehicles [account]="account" (saveEmitter)="refreshVehicleList()" #enrollVehiclesModal>
</app-enroll-vehicles>
<app-enrollment-status (saveEmitter)="refreshVehicleList()" #enrollmentStatusModal></app-enrollment-status>